import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject  } from 'rxjs';
export interface Param {
  vehicle: any;
  isMobile: boolean;
  type: string,
  vin?: string,
  product?: string,
  vehicleText?: string,
  tabIndex: number
}

@Injectable({
  providedIn: 'root'
})

export class MobileEcatalogService {
  // Home Page Privacy Agree Status
  private vehicleParamsSubject: BehaviorSubject<Param | null>;
  public vehicleParams: Observable<Param | null>;

  constructor(

  ) {
    const storedMobileProductParams= localStorage.getItem('mobileProductParams');
    this.vehicleParamsSubject = new BehaviorSubject<Param | null>(storedMobileProductParams ? JSON.parse(storedMobileProductParams) : null);
    this.vehicleParams = this.vehicleParamsSubject.asObservable();
  }

  sendVehicleParams(message: Param) {
    localStorage.setItem('mobileProductParams', JSON.stringify(message));
    this.vehicleParamsSubject.next(message);
  }
 



}

